import { Col, Row } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';

import classNames from 'classnames';

import { Footer } from '@components/Footer/Footer';
import LogoDark from '@components/Logo/Logo';
import { Page500 } from '@containers/ErrorPages';

const DefaultSpinner = ({ size = 'lg' }) => (
  <Spinner size={size} animation="border" variant="warning" />
);
export const DefaultSpinnerCenter = ({ className = '', size = 'lg' }) => (
  <Row className={classNames('text-center', className)}>
    <Col>
      <DefaultSpinner size={size} />
    </Col>
  </Row>
);
export default DefaultSpinner;

export const LoadingPage = ({ className = '' }) => (
  <>
    <div id="loginPage" className={classNames('text-center', className)}>
      <div className="form-signin">
        <LogoDark href="/" className="login-logo" />
        <DefaultSpinnerCenter />
      </div>
    </div>
    <Footer />
  </>
);

export const ServerErrorPage = () => (
  <>
    <div id="loginPage" className="login-body text-center">
      <div className="form-signin">
        <LogoDark href="/" className="login-logo" />
        <Page500 />
      </div>
    </div>
    <Footer />
  </>
);
